var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shipments)?_c('div',{attrs:{"id":"modalInvoice"}},_vm._l((_vm.shipments),function(item,i){return _c('v-container',{key:i},[_c('div',[_c('app-barcode',{attrs:{"shipment":item}})],1),_c('div',{staticClass:"pagebreak"})])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }